module.exports = __webpack_public_path__ + "static/media/img-destaque-home.6adcdf50.png";